import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { checkCookie } from "../../Utils/Utils";
import Header from "../../Content/Header/Header";
import { ENABLE_RESONATE_WEBSITE } from "../../../constants/Constants";

require("./ShareFeedback.scss");

class ShareFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  componentDidMount() {
    if (!ENABLE_RESONATE_WEBSITE) {
      this.setState({ redirect: true });
    }

    // ✅ Correct Jotform script
    const script = document.createElement("script");
    script.src = "https://form.jotform.com/jsform/261201428142040";
    script.async = true;

    const container = document.getElementById("jotform-container");
    if (container) {
      container.appendChild(script);
    }
  }

  render() {
    
    return (
      <div className="feedback-container">
        <Header />
        <div id="jotform-container" />
      </div>
    );
  }
}

export default ShareFeedback;